import { render, staticRenderFns } from "./BusinessOpportunityAdmin.vue?vue&type=template&id=a0879a2c&scoped=true"
import script from "./BusinessOpportunityAdmin.vue?vue&type=script&lang=js"
export * from "./BusinessOpportunityAdmin.vue?vue&type=script&lang=js"
import style0 from "./BusinessOpportunityAdmin.vue?vue&type=style&index=0&id=a0879a2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0879a2c",
  null
  
)

export default component.exports